
class PaoAddressCleaner {
    constructor(address, toFullForm = true) {
        this.address = address.toLowerCase(); 
        this.toFullForm = toFullForm;
        this.abbreviations = {
            "street": "st",
            "road": "rd",
            "circle": "cir",
            "avenue": "ave",
            "apartment": "apt",
            "suite": "ste",
            "unit": "unit",  
            "floor": "fl",
            "department": "dept"
        };
    }

    fullToAbbreviation(address) {
        return address.replace(/\b(street|road|circle|avenue|apartment|suite|unit|floor|department)\b/g, (match) => {
            return this.abbreviations[match];
        });
    }

    abbreviationToFull(address) {
        return address.replace(/\b(st|rd|cir|ave|apt|ste|fl|dept)\b/g, (match) => {
            return Object.keys(this.abbreviations).find(key => this.abbreviations[key] === match) || match;
        });
    }

    clean() {
        let cleanedAddress = this.address;

        if (this.toFullForm) {
            cleanedAddress = this.abbreviationToFull(cleanedAddress);  
        } else {
            cleanedAddress = this.fullToAbbreviation(cleanedAddress);  
        }

        return cleanedAddress.trim()  
            .replace(/\s+/g, '')  
            .replace(/[^a-z0-9]/g, '')  
            .replace(/\b0+(\d+)/g, '$1')  
            .toLowerCase();  
    }

    getCleanedAddress() {
        return this.clean(); 
    }
}